import { getCoreEmbeddedEndpoint } from './config';

const getPreviewUrl = (designId: string) => `${getCoreEmbeddedEndpoint()}/designs/${designId}/preview`;

export default getPreviewUrl;
